<script>
import { IconXmark } from '@/components/icons/index'

export default {
  name: "ModalFrame",

  components: {
    IconXmark,
  },

  props: {
    link: { type: String, default: "" },
  },

  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<template>
  <div class="modal-frame">
    <div class="modal-frame-wrapper">
      <div class="modal-frame-document">
        <iframe
          :src="link"
          width="100%"
          height="100%"
          scrolling="no"
        ></iframe>
      </div>
    </div>
    <div class="modal-frame-close-wrapper">
      <div class="modal-frame-close-button" @click="closeModal">
        <IconXmark size="20px" color-fill="#fff" />
      </div>
    </div>
    <div class="modal-frame-mask" @click="closeModal"></div>
  </div>
</template>

<style lang="scss">
.modal-frame {
  z-index: 1;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  z-index: 9997;

  &-wrapper {
    transform: translate(-50%, -50%) scale(1) rotate(0deg);
    top: calc(50% + -11px);
    left: calc(50% + 31px);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50% -50%);
    transform: translate(-50% -50%);
    -webkit-transition: .3s ease-in-out;
    transition: .3s ease-in-out;
    will-change: transform opacity;
    z-index: 9997;
  }

  &-mask {
    margin: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0,0,0,.5);
  }

  &-document {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    max-width: 90vw;
    max-height: 90vh;
    vertical-align: middle;
    position: relative;
    -webkit-transition: -webkit-transform .3s ease-in-out;
    transition: -webkit-transform .3s ease-in-out;
    transition: transform .3s ease-in-out;
    transition: transform .3s ease-in-out,-webkit-transform .3s ease-in-out;
    -webkit-box-shadow: rgb(0 0 0 / 70%) 0 5px 20px 2px;
    box-shadow: rgb(0 0 0 / 70%) 0 5px 20px 2px;
    background-color: rgba(0,0,0,.7);
    height: 297mm;
    width: 210mm
  }

  &-close {
    &-wrapper {
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      position: absolute;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      cursor: pointer;
      opacity: .6;
      font-size: 32px;
      color: #fff;
      -webkit-transition: .15s linear;
      transition: .15s linear;
      -webkit-tap-highlight-color: transparent;
      outline: 0;
      top: 24px;
      right: 10px;
      z-index: 9997;
    }

    &-button {
      svg {
        width: 1em;
      }
    }
  }
}
</style>
